import * as yup from 'yup';
import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const isFullMobilePhone = (value) => {
  return value && isValidPhoneNumber(value);
};

export const checkLoginField = (value) => {
  return isFullMobilePhone(value) || isEmail(value);
};

function checkLogin(ref, msg) {
  return this.test({
    name: 'checkLoginMethod',
    exclusive: false,
    message: msg || 'login not valid',
    params: { reference: ref ? ref.path : undefined },
    test(value) {
      return checkLoginField(value, this.resolve(ref));
    },
  });
}

function checkURL(ref, msg) {
  return this.test({
    name: 'checkURLMethod',
    exclusive: false,
    message: msg || 'URL not valid',
    params: { reference: ref ? ref.path : undefined },
    test(value) {
      return !value || isURL(value.toLowerCase(), { protocols: ['https'] });
    },
  });
}

function checkPhone(ref, msg) {
  return this.test({
    name: 'checkPhoneMethod',
    exclusive: false,
    message: msg || 'phone number not valid',
    params: { reference: ref ? ref.path : undefined },
    test(value) {
      return isFullMobilePhone(value, this.resolve(ref));
    },
  });
}

function checkPhoneWithEmpty(ref, msg) {
  return this.test({
    name: 'checkPhoneWithEmptyMethod',
    exclusive: false,
    message: msg || 'phone number not valid',
    params: { reference: ref ? ref.path : undefined },
    test(value) {
      if (value === '') return true;
      return isFullMobilePhone(value, this.resolve(ref));
    },
  });
}

yup.addMethod(yup.string, 'checkLoginMethod', checkLogin);
yup.addMethod(yup.string, 'checkURLMethod', checkURL);
yup.addMethod(yup.string, 'checkPhoneMethod', checkPhone);
yup.addMethod(yup.string, 'checkPhoneWithEmptyMethod', checkPhoneWithEmpty);

export default yup;
